import { DEFAULT_SETTINGS, FIGHTERS, STAGES } from './data.js';
const number = (value, min, max, label) => {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < min || value > max) throw new Error(`${label} must be between ${min} and ${max}.`);
  return value;
};
/** Whitelist fields. Never merge untrusted JSON into prototypes or arbitrary app state. */
export function validateConfig(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value) || value.version !== 1) throw new Error('Expected a RIFT version 1 configuration.');
  const result = structuredClone(DEFAULT_SETTINGS);
  for (const key of ['fighter1', 'fighter2']) if (value[key] !== undefined) {
    if (!Object.hasOwn(FIGHTERS, value[key])) throw new Error(`Unknown ${key}.`);
    result[key] = value[key];
  }
  for (const [key, options] of Object.entries({ mode: ['cpu', 'local', 'training'], stage: Object.keys(STAGES), difficulty: ['easy', 'normal', 'hard'] })) {
    if (value[key] !== undefined) { if (!options.includes(value[key])) throw new Error(`Unknown ${key}.`); result[key] = value[key]; }
  }
  for (const [key, min, max] of [['stocks', 1, 5], ['minutes', 1, 10], ['trainingDamage', 0, 300], ['modelHeight', 0.8, 4], ['modelYaw', 0, 360]]) {
    if (value[key] !== undefined) result[key] = number(value[key], min, max, key);
  }
  if (!Number.isInteger(result.stocks) || !Number.isInteger(result.minutes)) throw new Error('Stocks and minutes must be whole numbers.');
  for (const key of ['audio', 'debug']) if (value[key] !== undefined) { if (typeof value[key] !== 'boolean') throw new Error(`${key} must be true or false.`); result[key] = value[key]; }
  if (value.custom !== undefined) {
    if (!value.custom || typeof value.custom !== 'object' || Array.isArray(value.custom)) throw new Error('Invalid fighter settings.');
    const custom = {};
    for (const [key, min, max] of [['speed', 4, 13], ['jump', 10, 20], ['weight', 60, 160], ['gravity', 20, 50], ['power', 0.5, 1.6]]) if (value.custom[key] !== undefined) custom[key] = number(value.custom[key], min, max, key);
    if (value.custom.color !== undefined) { if (typeof value.custom.color !== 'string' || !/^#[\da-f]{6}$/i.test(value.custom.color)) throw new Error('Color must be a six-digit hex color.'); custom.color = value.custom.color; }
    if (value.custom.name !== undefined) { if (typeof value.custom.name !== 'string' || value.custom.name.trim().length < 1 || value.custom.name.length > 18) throw new Error('Fighter name must be 1-18 characters.'); custom.name = value.custom.name.trim(); }
    result.custom = custom;
  }
  if (value.animationMap !== undefined) {
    if (!value.animationMap || typeof value.animationMap !== 'object' || Array.isArray(value.animationMap)) throw new Error('Invalid animation map.');
    for (const key of ['idle', 'run', 'jump', 'fall', 'attack', 'hurt', 'shield']) {
      const clip = value.animationMap[key];
      if (clip !== undefined) { if (typeof clip !== 'string' || clip.length > 150) throw new Error('Invalid animation name.'); result.animationMap[key] = clip; }
    }
  }
  return result;
}
export function loadSettings(storage) {
  try { const raw = storage.getItem('rift.settings.v1'); return raw ? validateConfig(JSON.parse(raw)) : structuredClone(DEFAULT_SETTINGS); }
  catch { return structuredClone(DEFAULT_SETTINGS); }
}
export function saveSettings(storage, settings) {
  try { storage.setItem('rift.settings.v1', JSON.stringify(validateConfig(settings))); return true; } catch { return false; }
}
